class CurrentCar extends HTMLElement {
    constructor() {
        super();

        // Helper function to get cookie
        const getCookie = (name) => {
            const nameEQ = name + "=";
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                let cookie = cookies[i];
                while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
                if (cookie.indexOf(nameEQ) === 0) {
                    return decodeURIComponent(cookie.substring(nameEQ.length));
                }
            }
            return null;
        };

        const url = new URL(window.location);
        let car = url.searchParams.get('filter.p.m.custom.make_model_year');

        // If no URL parameter, try to get from cookie
        if (!car) {
            car = getCookie('selected_car');
        }

        if (!car) return;

        this.innerText = car.replaceAll('_', ' ');
      
        this.closest('.current-car-wrapper').classList.remove('car-not-defined');

        var has_car = car;
    }
}

window.customElements.define('current-car', CurrentCar);